import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CorpPopMenuService {
  private openPopovers = new Set<{ close: () => void }>();

  register(popover: { close: () => void }) {
    this.openPopovers.add(popover);
  }

  unregister(popover: { close: () => void }) {
    this.openPopovers.delete(popover);
  }

  closeAll() {
    this.openPopovers.forEach(p => p.close());
    this.openPopovers.clear();
  }
  // private currentPopover: { close: () => void } | null = null;

  // register(popover: { close: () => void }) {
  //   // Si un autre popover est déjà ouvert, on le ferme avant
  //   if (this.currentPopover && this.currentPopover !== popover) {
  //     this.currentPopover.close();
  //   }
  //   this.currentPopover = popover;
  // }

  // unregister(popover: { close: () => void }) {
  //   if (this.currentPopover === popover) {
  //     this.currentPopover = null;
  //   }
  // }
}